import { Injectable } from "@angular/core";
import { AppService } from "@irb/app.service";
import { IPortfolioResultResponse, IPortfolioResultSECRebal } from "@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.model";
import { IAlertDialogData } from "@irb/app.model";
import { IrbAppEvents } from "@irb/app.events";
import { PrOrdersService } from "@irb/irb-editors/editor-portfolio-result/services/pr-orders.service";
import { PrOrdersCacheService } from "@irb/irb-editors/editor-portfolio-result/services/pr-orders-cache.service";

@Injectable({
  providedIn: "root",
})
export class PrSpreadTradeService {
  constructor(private as: AppService, private pros: PrOrdersService, private procs: PrOrdersCacheService) {}

  createSpreadTradeEditWarningDialog(data: IPortfolioResultResponse, item: IPortfolioResultSECRebal, snapShotItem: IPortfolioResultSECRebal, cbFunc: Function, cbFuncCancel: Function) {
    this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
      dTitle: "Spread Trade Order Edit",
      msg: "Sell and Buy quantities must be equal in order for the trades to generate as a spread order. Continuing with the edit may cause the trades to generate as separate individual orders.",
      onProceed: () => {
        this.getSpreadTradeOrders(data, item.rollId, (items: Array<IPortfolioResultSECRebal>) => {
          items.forEach((item) => {
            item.isRollTransaction = false;
          });

          cbFunc();
        });
      },
      onCancel: () => {
        this.createSpreadTradeEditWarningDialogOnCancel(data, item, snapShotItem);
        cbFuncCancel();
      }
    } as IAlertDialogData);
  }

  createSpreadTradeEditWarningDialogOnCancel(data: IPortfolioResultResponse, item: IPortfolioResultSECRebal, snapShotItem: IPortfolioResultSECRebal) {
    item.txnType = snapShotItem.txnType;
    item.txnAmt = snapShotItem.txnAmt;
    item.txnShares = snapShotItem.txnShares;

    for(let i = 0; i < snapShotItem.lotRebalanceSummaryDTOList?.length; i++) {
      item.lotRebalanceSummaryDTOList[i].txnType = snapShotItem.lotRebalanceSummaryDTOList[i].txnType;
      item.lotRebalanceSummaryDTOList[i].txnAmt = snapShotItem.lotRebalanceSummaryDTOList[i].txnAmt;
      item.lotRebalanceSummaryDTOList[i].txnShares = snapShotItem.lotRebalanceSummaryDTOList[i].txnShares;
    }

    this.pros.calBasedonPOValChange(data, item);
  }

  getSpreadTradeOrders(data: IPortfolioResultResponse, spreadTradeMapId: number, cbFunc: Function) {
    const a: Array<IPortfolioResultSECRebal> = [];

    data.secRebalDTOList.forEach((item: IPortfolioResultSECRebal) => {
      if (item.rollId === spreadTradeMapId) {
        a.push(item);
      }
    });

    cbFunc(a);
  }

  confirmSpreadTradeIntegrity(data: IPortfolioResultResponse, item: IPortfolioResultSECRebal, snapShotItem: IPortfolioResultSECRebal, cbFunc: Function, cbFuncCancel: Function) {
    this.getSpreadTradeOrders(data, item.rollId, (items: Array<IPortfolioResultSECRebal>) => {
      this.createAfterConfirm(data, item, snapShotItem, cbFunc, cbFuncCancel, items);
    });
  }

  createAfterConfirm(data: IPortfolioResultResponse, item: IPortfolioResultSECRebal, snapShotItem: IPortfolioResultSECRebal, cbFunc: Function, cbFuncCancel: Function, items: Array<IPortfolioResultSECRebal>) {
    let buyCount = 0;
    let sellCount = 0;
    let txnSharesTotal = 0;

    for (let i = 0; i < items.length; i++) {
      switch (items[i].txnType) {
        case "BUY_TO_CLOSE":
          txnSharesTotal += items[i].txnShares;
          buyCount++;
          break;
        case "SELL_TO_OPEN":
          txnSharesTotal -= items[i].txnShares;
          sellCount++;
          break;
        case "BUY_TO_OPEN":
          txnSharesTotal -= items[i].txnShares;
          buyCount++;
          break;
        case "SELL_TO_CLOSE":
          txnSharesTotal += items[i].txnShares;
          sellCount++;
          break;
      }
    }

    if (item.isRollTransaction && (buyCount !== 1 || sellCount !== 1 || txnSharesTotal !== 0)) {
      this.createSpreadTradeEditWarningDialog(data, item, snapShotItem, cbFunc, cbFuncCancel);
    } else {
      if (!item.isRollTransaction && buyCount === 1 && sellCount === 1 && txnSharesTotal === 0) {
        items.forEach((_item) => {
          _item.isRollTransaction = true;
        });
      }

      cbFunc();
    }
  }
}
